function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export const calcMaximumRepresentativeSearch = (cards, actions) => {
    const searches = cards
        .map(card => card.representativeSearch)
        .concat(actions.map(action => action.representativeSearch))
        .filter(search => !!search && !!search.levels && search.levels.length);
    const levels = [].concat.apply([], searches.map(s => s.levels)).filter(onlyUnique);
    const roles = [].concat.apply([], searches.map(s => s.roles)).filter(onlyUnique);
    return { levels, roles };
};
